import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { throwError } from 'rxjs';
import { appendRelativePathToUrl } from '@tmhcc/util';
import { AppConfig } from '@tmhcc-ng-lib/models';
import { map } from 'rxjs/internal/operators/map';
import { catchError } from 'rxjs/internal/operators/catchError';
import { of } from 'rxjs/internal/observable/of';
import cloneDeep from 'lodash-es/cloneDeep';
import { GlobalVariablesService } from './global-variables.service';
import { BaseDataService } from './base-data-service';

@Injectable()
export class FormBuildService extends BaseDataService {
  protected config: AppConfig;
  protected serviceBaseUrl: string;

  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService,
    protected globalVariables: GlobalVariablesService
  ) {
    super(http, configService, globalVariables);

    this.serviceBaseUrl = appendRelativePathToUrl(
      configService.config.dataServiceBaseUrl,
      '/formbuilder/'
    );
  }

  protected data = new Map();

  getForm(formId): Observable<any> {
    if (this.data.has(formId)) {
      ///TODO: Temporary code until UCM have the permanent fix
      const clonedData = cloneDeep(this.data.get(formId));
      this.data.set(formId, clonedData);
      return of(clonedData);
      //return of(this.data.get(formId)); -- Revert to this after permanent fix
    }

    return this.fetchForm(formId);
  }

  private handleError(err) {
    //return throwError(err);
    return throwError("We apologize for the inconvenience. Services may be slow at the moment, so please wait for a while and try again.");
  }

  private fetchForm(formId) {
    return this.get<any>(
      appendRelativePathToUrl(this.serviceBaseUrl, formId)
    ).pipe(
      map(data => {
        this.data.set(formId, data);
        return data;
      }),
      catchError(this.handleError)
    );
  }
}
